import { useEffect } from "react";
import { useState } from "react";
import referralFormValidationHelper from "./referralFormValidationHelper";
import referralService from "./referralService";
import { ReactComponent as ReferralLogo } from "../../../assets/imgs/referral.svg";

const ReferralForm = ({ selectedOfficeId, username, loggedInLawFirmName, searchId }) => {

    const [firmName, setFirmName] = useState("");
    const [address, setAddress] = useState("");
    const [postcode, setPostcode] = useState("");
    const [regulationRegistrationNumber, setRegulationRegistrationNumber] = useState("");
    const [accountName, setAccountName] = useState("");
    const [sortCode, setSortCode] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [orderNumber, setOrderNumber] = useState("");
    const [emailAddress, setEmailAddress] = useState("");

    const [firmNameIsValid, setFirmNameIsValid] = useState(false);
    const [addressIsValid, setAddressIsValid] = useState(false);
    const [postcodeIsValid, setPostcodeIsValid] = useState(false);
    const [sortCodeIsValid, setSortCodeIsValid] = useState(false);
    const [accountNumberIsValid, setAccountNumberIsValid] = useState(false);
    const [emailAddressIsValid, setEmailAddressIsValid] = useState(false);

    useEffect(() => {
        setFirmNameIsValid(referralFormValidationHelper.isFirmNameValid(firmName));
        setAddressIsValid(referralFormValidationHelper.isAddressValid(address));
        setPostcodeIsValid(referralFormValidationHelper.isPostcodeValid(postcode));
        setSortCodeIsValid(referralFormValidationHelper.isSortCodeValid(sortCode));
        setAccountNumberIsValid(referralFormValidationHelper.isAccountNumberValid(accountNumber));
        setEmailAddressIsValid(referralFormValidationHelper.isEmailAddressValid(emailAddress));
    }, [firmName, address, postcode, sortCode, accountNumber, emailAddress]);


    const [searchIdIsValid, setSearchIdIsValid] = useState(false);

    useEffect(() => setSearchIdIsValid(searchId !== undefined && searchId !== null), [searchId]);

    //ONLY AFTER ATTEMPTED SUBMISSION
    const [showValidation, setShowValidation] = useState(false);

    const [isSubmittingReferral, setIsSubmittingReferral] = useState(false);
    const [referralHasBeenSubmitted, setReferralHasBeenSubmitted] = useState(false);
    const [referralSubmissionHasErrored, setReferralSubmissionHasErrored] = useState(false);
    const [showInvalidFormMessage, setShowInvalidFormMessage] = useState(false);

    const onSubmit = e => {
        e.preventDefault();

        setShowValidation(true);

        setReferralHasBeenSubmitted(false);
        setReferralSubmissionHasErrored(false);

        var isAnyFieldInvalid = !firmNameIsValid || !addressIsValid || !postcodeIsValid || !sortCodeIsValid || !accountNumberIsValid || !emailAddressIsValid || !searchIdIsValid;

        setShowInvalidFormMessage(isAnyFieldInvalid);

        if (isAnyFieldInvalid) return;

        setIsSubmittingReferral(true);

        let submission = {
            searchId,
            firmName,
            address,
            postcode,
            regulationRegistrationNumber,
            accountName,
            sortCode,
            accountNumber,
            orderNumber,
            emailAddress
        };

        referralService.submitReferralAsync(submission, selectedOfficeId, username, loggedInLawFirmName)
            .then(() => {
                setReferralHasBeenSubmitted(true);
                setShowValidation(false);
                setFirmName("");
                setAddress("");
                setPostcode("");
                setRegulationRegistrationNumber("");
                setAccountName("");
                setSortCode("");
                setAccountNumber("");
                setOrderNumber("");
                setEmailAddress("");
            })
            .catch(() => setReferralSubmissionHasErrored(true))
            .finally(() => setIsSubmittingReferral(false));
    }

    return (
        <form data-testid="formReferralSubmission" onSubmit={onSubmit}>
            <div className="row pt-3">
                <div className="col-12 fs-3">
                    <ReferralLogo style={{ height: 75 }} />
                    &nbsp;&nbsp;&nbsp;STILL CAN'T FIND THE LAW FIRM?
                </div>
            </div>
            <div className="row pt-3">
                <div className="col-12">
                    Enter the details of the firm you were trying to find. You will receive a response from our team within 4 working hours. All referral submissions before 4pm will be completed the same day.
                </div>
            </div>
            <div className="row mt-4 mb-4">
                <div className="col-12">
                    <div className="form-group">
                        <label for="inputFirmName">Firm name <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className={`form-control ${showValidation ? firmNameIsValid ? "is-valid" : "is-invalid" : ""}`}
                            id="inputFirmName"
                            placeholder="Enter law firm name"
                            value={firmName}
                            onChange={e => setFirmName(e.target.value)}
                            disabled={isSubmittingReferral}
                        />
                        <div class="invalid-feedback">
                            Please provide a firm name
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-12">
                    <div className="form-group">
                        <label for="inputAddress">Address <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className={`form-control ${showValidation ? addressIsValid ? "is-valid" : "is-invalid" : ""}`}
                            id="inputAddress"
                            placeholder="Enter law firm address"
                            value={address}
                            onChange={e => setAddress(e.target.value)}
                            disabled={isSubmittingReferral}
                        />
                        <div class="invalid-feedback">
                            Please provide an address for the firm
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-12">
                    <div className="form-group">
                        <label for="inputPostcode">Postcode <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className={`form-control ${showValidation ? postcodeIsValid ? "is-valid" : "is-invalid" : ""}`}
                            id="inputPostcode"
                            placeholder="Enter law firm postcode"
                            value={postcode}
                            onChange={e => setPostcode(e.target.value)}
                            disabled={isSubmittingReferral}
                        />
                        <div class="invalid-feedback">
                            Please provide a valid postcode for the firm
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-12">
                    <div className="form-group">
                        <label for="inputRrNumber">Regulation registration number</label>
                        <input
                            type="text"
                            className="form-control"
                            id="inputRrNumber"
                            placeholder="Enter law firm regulation registration number"
                            value={regulationRegistrationNumber}
                            onChange={e => setRegulationRegistrationNumber(e.target.value)}
                            disabled={isSubmittingReferral}
                        />
                    </div>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-12">
                    <div className="form-group">
                        <label for="inputAccountName">Account name</label>
                        <input
                            type="text"
                            className="form-control"
                            id="inputAccountName"
                            placeholder="Enter law firm account name"
                            value={accountName}
                            onChange={e => setAccountName(e.target.value)}
                            disabled={isSubmittingReferral}
                        />
                    </div>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-12">
                    <div className="form-group">
                        <label for="inputSortCode">Sort code <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className={`form-control ${showValidation ? sortCodeIsValid ? "is-valid" : "is-invalid" : ""}`}
                            id="inputSortCode"
                            placeholder="Enter law firm sort code"
                            value={sortCode}
                            onChange={e => setSortCode(e.target.value)}
                            disabled={isSubmittingReferral}
                        />
                        <div class="invalid-feedback">
                            Please provide a valid sort code for the firm
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-12">
                    <div className="form-group">
                        <label for="inputAccountNumber">Account number <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className={`form-control ${showValidation ? accountNumberIsValid ? "is-valid" : "is-invalid" : ""}`}
                            id="inputAccountNumber"
                            placeholder="Enter law firm account number"
                            value={accountNumber}
                            onChange={e => setAccountNumber(e.target.value)}
                            disabled={isSubmittingReferral}
                        />
                        <div class="invalid-feedback">
                            Please provide a valid account number for the firm
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-12">
                    <div className="form-group">
                        <label for="inputOrderNumber">Order number</label>
                        <input
                            type="text"
                            className="form-control"
                            id="inputOrderNumber"
                            placeholder="Enter law firm order number"
                            value={orderNumber}
                            onChange={e => setOrderNumber(e.target.value)}
                            disabled={isSubmittingReferral}
                        />
                    </div>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-12">
                    <div className="form-group">
                        <label for="inputEmailAddress">Email Address<span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className={`form-control ${showValidation ? emailAddressIsValid ? "is-valid" : "is-invalid" : ""}`}
                            id="inputEmailAddress"
                            placeholder="Enter email address to receive the manual assessment"
                            value={emailAddress}
                            onChange={e => setEmailAddress(e.target.value)}
                            disabled={isSubmittingReferral}
                        />
                        <div class="invalid-feedback">
                            Please provide a valid email address
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-12">
                    <div className="form-group">
                        <button type="submit" disabled={isSubmittingReferral} className="btn btn-outline-dark">SEND REFERRAL FOR REVIEW</button>
                    </div>
                </div>
            </div>
            {
                referralHasBeenSubmitted &&
                <div data-testid="divSubmissionSuccess" className="row mb-4">
                    <div className="col-12">
                        <p className="text-success">Your referral has been successfully submitted. You should receive a response from our team within 4 working hours. All referral submissions before 4pm will be completed the same day.</p>
                    </div>
                </div>
            }
            {
                referralSubmissionHasErrored &&
                <div className="row mb-4">
                    <div className="col-12">
                        <p className="text-danger">There has been an error submitting your referral, please try again. If the issue persists contact please contact the team on 0343 221 0610.</p>
                    </div>
                </div>
            }
            {
                showInvalidFormMessage &&
                <div className="row mb-4">
                    <div className="col-12">
                        <p className="text-danger">There is a problem with your form, please review and resubmit.</p>
                    </div>
                </div>
            }
        </form>
    )
};

export default ReferralForm;